import React, { } from 'react';
import Scanner from 'domain/barcode-scanner/screens/scanner';
import { useScannerScreen } from 'domain/create-opportunity/hooks/use-scanner-screen';

export default function ScannerScreen() {
  const { handleBack, handleOpportunity } = useScannerScreen();
  return <Scanner onBack={handleBack} onScan={handleOpportunity} />;
}
